/** 目標/計畫/每期保費暨配置比例/繳別變更 */
import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';
const url = 'api/IQ';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

/** 取得問卷資料 */
export function getInfoIQ(questNo) {
    return get(`${url}/info`, { questNo });
};

/** 送出問卷資料 */
export function submitIQ(data) {
    return post(`${url}/submit`, data, { ...options, repeatRequestCancel: true });
}
